/** CSS media query matching primary-input touch semantics */
export const PRIMARY_TOUCH_QUERY = '(hover: none) and (pointer: coarse)';

/**
 * Detect iPadOS regardless of attached accessories.
 *
 * Product decision: "iPad é iPad, pouco importa trackpad."
 * When Magic Keyboard (trackpad) is connected, iPadOS reports
 * (hover: hover) and (pointer: fine), but the device must remain
 * in iPad/touch mode for the Bigwa UX.
 *
 * Detection:
 *  - Pre-iPadOS 13: UA contains "iPad" explicitly.
 *  - iPadOS 13+: UA mimics macOS ("Macintosh") but real Macs
 *    report maxTouchPoints === 0; iPads report > 1.
 */
function isIPadOS(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/iPad/.test(ua)) return true;
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return true;
  return false;
}

/**
 * True if the device should be treated as "touch primary".
 *
 * Uses CSS @media (hover: none) and (pointer: coarse) as the baseline,
 * with an iPadOS override so that iPads are always touch-primary
 * regardless of Magic Keyboard / trackpad state.
 *
 * Dell touchscreen with trackpad → false (hover detected, pointer fine).
 * iPad real → true (media query matches directly).
 * iPad + Magic Keyboard → true (iPadOS override).
 */
export function hasPrimaryTouch(): boolean {
  if (typeof window === 'undefined') return false;
  if (window.matchMedia(PRIMARY_TOUCH_QUERY).matches) return true;
  // Product decision: iPad is always touch-primary.
  return isIPadOS();
}
